/**
 * Product surfaces should not show DW / gold technical identifiers.
 * Keep human labels (INDEC, BCRA, “Desempleo”, …); drop codes like
 * AR_IPC_VAR_MOM, gold.AR_*, gold:AR_EPH_DESEMPLEO_NAC.
 */

export function isTechnicalIndicatorId(value) {
  if (value == null) return false;
  const s = String(value).trim();
  if (!s) return false;
  if (/^gold[:./]/i.test(s)) return true;
  if (/\bgold[:.][A-Z0-9_]+/i.test(s)) return true;
  if (/^[A-Z]{2}_[A-Z0-9_]+$/i.test(s)) return true;
  return false;
}

/** Human source for provenance / freshness; null when technical. */
export function humanReadableSource(value) {
  if (value == null || value === '') return null;
  const s = String(value).trim();
  if (isTechnicalIndicatorId(s)) return null;
  return s;
}

/**
 * Human label for titles / metrics / chart series.
 * Never falls back to a technical id — use `fallback` (or null) instead.
 */
export function humanReadableLabel(value, fallback = null) {
  if (value == null || value === '') return fallback;
  const s = String(value).trim();
  if (isTechnicalIndicatorId(s)) return fallback;
  return s;
}
